const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
};

const formatRequestOptions = (data, method = 'POST') => {
  const csrfToken = getCsrfToken();
  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json',
    },
    body: data ? JSON.stringify(data) : null,
  };
};

const returnFetchPromise = (url, data, method) => {
  const requestOptions = formatRequestOptions(data, method);
  return fetch(url, requestOptions);
};

export const login = async (email, password) => {
  try {
    const response = await returnFetchPromise(
      '/api/v2/login',
      { user: { email, password } },
      'POST',
    );

    const contentType = response.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Unexpected server response. Please try again.');
    }

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    }
    return { success: false, error: data.error };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
